"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Html", {
  enumerable: true,
  get: function get() {
    return _html["default"];
  }
});
exports.getNewContent = exports["default"] = void 0;
Object.defineProperty(exports, "toHtml", {
  enumerable: true,
  get: function get() {
    return _toHtml["default"];
  }
});
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLoadGlobalLibrary = _interopRequireDefault(require("cccisd-load-global-library"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _update2 = _interopRequireDefault(require("lodash/update"));
var _jquery = _interopRequireDefault(require("jquery"));
var _uuid = _interopRequireDefault(require("./uuid.js"));
var _Audio = _interopRequireDefault(require("./plugins/Audio"));
var _ResourceImage = _interopRequireDefault(require("./plugins/ResourceImage"));
var _Variables = _interopRequireDefault(require("./plugins/Variables"));
var _WordTimings = _interopRequireDefault(require("./plugins/WordTimings"));
var _Tooltip = _interopRequireDefault(require("./plugins/Tooltip"));
var _Information = _interopRequireDefault(require("./plugins/Information"));
var _Icons = _interopRequireDefault(require("./plugins/Icons"));
var _style = _interopRequireDefault(require("./style.css"));
var _editor = _interopRequireDefault(require("./editor.js"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _html = _interopRequireDefault(require("./html.js"));
var _toHtml = _interopRequireDefault(require("./toHtml.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable func-names, space-before-function-paren */
(0, _update2["default"])(window, 'cccisd.temp.wysiwyg', function (n) {
  return n || {};
});
var config = (0, _get2["default"])(window, 'cccisd.temp.wysiwyg');
/** WYSIWYG editor based on TINYMCE */
var Wysiwyg = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Wysiwyg, _React$Component);
  function Wysiwyg(props, context) {
    var _this;
    _classCallCheck(this, Wysiwyg);
    _this = _callSuper(this, Wysiwyg, [props]);
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var settings, validOptions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this._mountTinymce();
          case 2:
            _context.next = 4;
            return _this._mountToolbarWrapper();
          case 4:
            settings = _this._getEditorSettings();
            _context.next = 7;
            return window.tinymce.init(settings);
          case 7:
            validOptions = ['start', 'end', 'select-all'];
            if (validOptions.includes(_this.props.autofocus) && !config.isAutofocused) {
              // Give Tinymce some time to setup editor
              setTimeout(function () {
                // focus on this instance of TinyMCE
                (0, _jquery["default"])('#' + _this.id).focus();

                // We need to autofocus only one tinymce at time
                // We're saving autofocus state in a global array
                // And resetting it after a while
                config.isAutofocused = true;
                setTimeout(function () {
                  config.isAutofocused = false;
                }, 100);
                if (_this.props.selectAllOnFocus || _this.props.autofocus === 'start') {
                  return;
                }
                var s = window.getSelection();
                var r = s.getRangeAt(0);

                // select all
                r.setStart(s.focusNode, 0);
                r.setEnd(s.focusNode, s.focusNode.length);
                s.addRange(r);
                if (_this.props.autofocus === 'select-all') {
                  return;
                }

                // collspase selection to just the end
                // this effectively moves the cursor to the end
                s.collapseToEnd();
              }, 100);
            }
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearInterval(_this.intervalId);
      clearTimeout(_this.timeoutId);
      if (window.tinymce) {
        window.tinymce.EditorManager.execCommand('mceRemoveEditor', true, _this.id);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_onChange", function (text, meta) {
      // We have to save variables because user can remove variable and then undo the change
      // In this case we will restore variable from here
      _this.variables = _objectSpread(_objectSpread({}, _this.variables), meta && meta.variables || {});

      // ditto on images
      _this.images = _objectSpread(_objectSpread({}, _this.images), meta && meta.images || {});

      // ditto on tooltips
      _this.tooltips = _objectSpread(_objectSpread({}, _this.tooltips), meta && meta.tooltips || {});
      _this.content = getNewContent(text, meta, _this.variables, _this.images, _this.tooltips);
      _this.props.onChange(_this.content);
    });
    _defineProperty(_assertThisInitialized(_this), "_mountTinymce", function () {
      return (0, _cccisdLoadGlobalLibrary["default"])('tinymce', '//dm0gz550769cd.cloudfront.net/core_assets/tinymce_4.6.7/tinymce.full.min.js');
    });
    _defineProperty(_assertThisInitialized(_this), "_mountToolbarWrapper", function () {
      return new Promise(function (resolve, reject) {
        if ((0, _jquery["default"])('#' + _this.wrapperId).length === 0) {
          var div = document.createElement('div');
          div.setAttribute('id', _this.wrapperId);
          div.setAttribute('style', 'position: fixed; top: 0; right: 0; z-index: 1500');
          document.body.appendChild(div);
        }
        resolve();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_mountStylesheet", function (href) {
      if ((0, _jquery["default"])("head link[href=\"".concat(href, "\"]")).length === 0) {
        var link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('href', href);
        document.head.appendChild(link);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getIcons", function () {
      if (_this.state.focused) {
        return null;
      }
      var icons = [];
      _this.plugins.forEach(function (plugin) {
        if (plugin.addIcon) {
          var icon = plugin.addIcon(_this.content);
          if (icon) {
            if (!(0, _isArray2["default"])(icon)) {
              icon = [icon];
            }
            icons = [].concat(_toConsumableArray(icons), _toConsumableArray(icon));
          }
        }
      });
      if (icons.length === 0) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].iconWrapper
      }, icons.reverse().map(function (icon, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].icon,
          key: index
        }, icon);
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_getEditorSettings", function () {
      var $this = _assertThisInitialized(_this);
      var settings = {};
      switch (_this.props.type) {
        case 'textarea':
          {
            break;
          }
        case 'textarea-inline':
          {
            settings = {
              inline: true,
              fixed_toolbar_container: '#' + _this.wrapperId
            };
            break;
          }
        case 'input':
          {
            settings = {
              inline: true,
              fixed_toolbar_container: '#' + _this.wrapperId,
              forced_root_block: false,
              menubar: false,
              toolbar: ['styleselect bold italic underline | forecolor backcolor | code | cccisdAudio cccisdWordTimings cccisdImageResource cccisdVariables | cccisdTooltip cccisdInformation cccisdIcons']
            };
            break;
          }
        default:
          {
            if (_this.props.type && _this.props.type !== '') {
              console.error("There is no \"".concat(_this.props.type, "\" type for WYSIWYG-editor"));
            } else {
              console.error('You should provide type prop for WYSIWYG-editor');
            }
            break;
          }
      }
      return _objectSpread(_objectSpread({
        selector: '#' + _this.id,
        plugins: ['charmap lists link hr code table paste textcolor noneditable'],
        menubar: 'edit insert format table tools',
        toolbar: ['bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor | hr charmap', 'formatselect styleselect | link unlink | table | code | cccisdAudio cccisdWordTimings cccisdImageResource cccisdVariables | cccisdTooltip cccisdInformation cccisdIcons'],
        extended_valid_elements: 'svg[*],g[*],path[*]',
        hidden_input: false,
        browser_spellcheck: true,
        relative_urls: false,
        block_formats: 'Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3;Preformatted=pre',
        style_formats: [{
          title: 'Small',
          inline: 'span',
          styles: {
            fontSize: '0.8em'
          }
        }, {
          title: 'Normal',
          inline: 'span',
          styles: {
            fontSize: '1em'
          }
        }, {
          title: 'Large',
          inline: 'span',
          styles: {
            fontSize: '1.2em'
          }
        }, {
          title: 'Huge',
          inline: 'span',
          styles: {
            fontSize: '1.4em'
          }
        }, {
          title: 'Enormous',
          inline: 'span',
          styles: {
            fontSize: '1.6em'
          }
        }],
        table_default_attributes: {
          "class": 'table table-bordered'
        },
        table_default_styles: {
          width: '100%'
        },
        table_class_list: [{
          title: 'None',
          value: "table ".concat(_style["default"].borderless)
        }, {
          title: 'Bordered',
          value: 'table table-bordered'
        }, {
          title: 'Striped',
          value: 'table table-bordered table-striped'
        }],
        table_row_class_list: [{
          title: 'None',
          value: ''
        }, {
          title: 'Active',
          value: 'active'
        }, {
          title: 'Success',
          value: 'success'
        }, {
          title: 'Warning',
          value: 'warning'
        }, {
          title: 'Danger',
          value: 'danger'
        }, {
          title: 'Info',
          value: 'info'
        }],
        table_cell_class_list: [{
          title: 'None',
          value: ''
        }, {
          title: 'Active',
          value: 'active'
        }, {
          title: 'Success',
          value: 'success'
        }, {
          title: 'Warning',
          value: 'warning'
        }, {
          title: 'Danger',
          value: 'danger'
        }, {
          title: 'Info',
          value: 'info'
        }],
        table_responsive_width: true,
        paste_webkit_styles: 'color font-size',
        init_instance_callback: function init_instance_callback(editor) {
          editor.on('Change KeyPress KeyUp Undo Redo', function (e) {
            $this._onChange(editor.getContent(), $this.content.meta);
          });
          editor.on('Blur', function (e) {
            $this.props.onBlur(editor.getContent());
            if ($this.state.focused) {
              $this.setState({
                focused: false
              });
            }
          });
          editor.on('Focus', function (e) {
            if ($this.props.selectAllOnFocus) {
              editor.execCommand('selectAll');
            }
            if (!$this.state.focused) {
              $this.setState({
                focused: true
              });
            }
          });
        },
        setup: function setup(editor) {
          (0, _forEach2["default"])($this.plugins, function (plugin) {
            editor.addButton(plugin.name, _objectSpread(_objectSpread(_objectSpread({}, plugin.icon && {
              icon: plugin.icon
            }), plugin.image && {
              image: plugin.image
            }), {}, {
              text: plugin.text,
              tooltip: plugin.tooltip,
              onPostRender: function onPostRender() {
                var ctrl = this;
                if (plugin.activeCondition) {
                  editor.on('NodeChange', function (e) {
                    ctrl.active(plugin.activeCondition(e.element, $this.content.meta));
                  });
                }
                if (plugin.disableCondition) {
                  editor.on('NodeChange', function (e) {
                    ctrl.disabled(plugin.disableCondition(editor.getContent(), $this.content.meta, e.element, editor.selection.getContent()));
                  });
                }
              },
              onclick: function onclick() {
                var bookmark = editor.selection.getBookmark();
                var insertContent = function insertContent(text) {
                  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $this.content.meta;
                  $this.refs.modal.close();
                  editor.focus();
                  editor.selection.moveToBookmark(bookmark);
                  editor.insertContent(text);

                  // Update text in redux
                  var wholeText = editor.getContent();
                  $this._onChange(wholeText, meta);
                };
                var setContent = function setContent(text) {
                  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $this.content.meta;
                  $this.refs.modal.close();
                  editor.focus();
                  editor.selection.moveToBookmark(bookmark);
                  editor.setContent(text);

                  // Update text in redux
                  $this._onChange(text, meta);
                };
                var Component = plugin.component;
                $this.setState({
                  popupContent: /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
                    fallback: /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
                      loading: true
                    })
                  }, /*#__PURE__*/_react["default"].createElement(Component, {
                    content: editor.getContent(),
                    meta: $this.content.meta || {},
                    selectedContent: editor.selection.getContent(),
                    insertContent: insertContent,
                    setContent: setContent
                  })),
                  popupTitle: plugin.title,
                  popupSize: plugin.modalSize || 'normal'
                }, function () {
                  $this.refs.modal.open();
                });
              }
            }));
          });
        }
      }, settings), _this.props.settings);
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var content = _this.props.content;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].editorWrapper
      }, _this._getIcons(), /*#__PURE__*/_react["default"].createElement(_editor["default"], {
        id: _this.id,
        content: (0, _isString2["default"])(content) ? content : (content === null || content === void 0 ? void 0 : content.content) || '',
        inputStyle: _this.props.inputStyle
      }), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: _this.state.popupTitle,
        trigger: null,
        ref: "modal",
        size: _this.state.popupSize
      }, _this.state.popupContent));
    });
    _this.id = (0, _uuid["default"])();
    _this.intervalId = null;
    _this.timeoutId = null;
    _this.checkInterval = 50;
    _this.checkTimeout = 5000;
    _this.wrapperId = 'cccisd-tinymce-wrapper';
    _this.content = props.content || '';
    _this.variables = {};
    _this.images = {};
    _this.tooltips = {};
    _this.plugins = [_Audio["default"], _ResourceImage["default"], _WordTimings["default"], _Tooltip["default"], _Information["default"], _Icons["default"]];
    if (context.flow) {
      _this.plugins.push(_Variables["default"]);
    }
    _this.state = {
      popupContent: null,
      popupTitle: 'Plugin settings',
      popupSize: 'normal',
      focused: false
    };
    return _this;
  }
  return _createClass(Wysiwyg);
}(_react["default"].Component);
_defineProperty(Wysiwyg, "propTypes", {
  /** Initial content of the editor. */
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  /** The type of Editor. <br> <i>I.e.</i>: 'textarea', 'textarea-inline', and 'input' */
  type: _propTypes["default"].string,
  /** Used to override TinyMCE settings. */
  settings: _propTypes["default"].object,
  /** Whether to auto focus on an input field once the Editor mounts. <br> Options: 'start', 'end', and 'select-all' */
  autofocus: _propTypes["default"].string,
  /** Callback function that runs when the Editor's content is changed. */
  onChange: _propTypes["default"].func,
  /** Callback function that runs when an input field loses focus. */
  onBlur: _propTypes["default"].func,
  /** Custom style for input area */
  inputStyle: _propTypes["default"].object,
  /** Selects all text on focus when true. */
  selectAllOnFocus: _propTypes["default"].bool
});
_defineProperty(Wysiwyg, "defaultProps", {
  content: '',
  type: 'textarea-inline',
  settings: {},
  autofocus: null,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  inputStyle: {},
  selectAllOnFocus: false
});
_defineProperty(Wysiwyg, "contextTypes", {
  flow: _propTypes["default"].object
});
var getNewContent = exports.getNewContent = function getNewContent(text, meta, savedVariables, savedImages, savedTooltips) {
  var newContent = {
    content: text,
    meta: meta
  };
  function getContentVariables(content) {
    var regex = /data-variable="([^"]*)"/g;
    var vars = [];
    var result;
    // eslint-disable-next-line no-cond-assign
    while (result = regex.exec(newContent.content)) {
      vars.push(result[1]);
    }
    return vars;
  }
  function getContentImages(content) {
    var regex = /data-image="([^"]*)"/g;
    var images = [];
    var result;
    // eslint-disable-next-line no-cond-assign
    while (result = regex.exec(newContent.content)) {
      images.push(result[1]);
    }
    return images;
  }
  function getContentTooltips(content) {
    var regex = /data-tooltip="([^"]*)"/g;
    var vars = [];
    var result;
    // eslint-disable-next-line no-cond-assign
    while (result = regex.exec(newContent.content)) {
      vars.push(result[1]);
    }
    return vars;
  }
  var contentVariables = getContentVariables(newContent.content);
  var contentImages = getContentImages(newContent.content);
  var contentTooltips = getContentTooltips(newContent.content);

  // Restore variable from buffer if user did an undo
  if (contentVariables.length > 0) {
    var metaVariables = newContent.meta && newContent.meta.variables || {};
    var missedVariables = (0, _difference2["default"])(contentVariables, (0, _keys2["default"])(metaVariables));
    (0, _set2["default"])(newContent, 'meta.variables', _objectSpread(_objectSpread({}, metaVariables), (0, _pick2["default"])(savedVariables, missedVariables)));
  }

  // Remove variables from meta if they have been removed from text
  if (newContent.meta && newContent.meta.variables) {
    newContent.meta.variables = (0, _pick2["default"])(newContent.meta.variables, contentVariables);
    if ((0, _isEqual2["default"])(newContent.meta.variables, {})) {
      newContent.meta = (0, _omit2["default"])(newContent.meta, 'variables');
    }
  }

  // ------

  // Restore image from buffer if user did an undo
  if (contentImages.length > 0) {
    var metaImages = newContent.meta && newContent.meta.images || {};
    var missedImages = (0, _difference2["default"])(contentImages, (0, _keys2["default"])(metaImages));
    (0, _set2["default"])(newContent, 'meta.images', _objectSpread(_objectSpread({}, metaImages), (0, _pick2["default"])(savedImages, missedImages)));
  }

  // Remove image from meta if they have been removed from text
  if (newContent.meta && newContent.meta.images) {
    newContent.meta.images = (0, _pick2["default"])(newContent.meta.images, contentImages);
    if ((0, _isEqual2["default"])(newContent.meta.images, {})) {
      newContent.meta = (0, _omit2["default"])(newContent.meta, 'images');
    }
  }

  // ------

  // Restore tooltip from buffer if user did an undo
  if (contentTooltips.length > 0) {
    var metaTooltips = newContent.meta && newContent.meta.tooltips || {};
    var missedTooltips = (0, _difference2["default"])(contentTooltips, (0, _keys2["default"])(metaTooltips));
    (0, _set2["default"])(newContent, 'meta.tooltips', _objectSpread(_objectSpread({}, metaTooltips), (0, _pick2["default"])(savedTooltips, missedTooltips)));
  }

  // Remove tooltips from meta if they have been removed from text
  if (newContent.meta && newContent.meta.tooltips) {
    newContent.meta.tooltips = (0, _pick2["default"])(newContent.meta.tooltips, contentTooltips);
    if ((0, _isEqual2["default"])(newContent.meta.tooltips, {})) {
      newContent.meta = (0, _omit2["default"])(newContent.meta, 'tooltips');
    }
  }

  // ------

  // Return result as a string if meta is an empty object
  if (!newContent.meta || (0, _isEqual2["default"])(newContent.meta, {})) {
    newContent = newContent.content;
  }
  return newContent;
};